import { defineStore } from 'pinia'
import { ref } from 'vue'

export type TrackingUserData = {
  userId: string
  location_id: string
  organization_id: string
  id: string
}

export const useTrackingStore = defineStore('tracking', () => {
  const currentUserData = ref<TrackingUserData>()

  function getTracker() {
    // Use the globally exposed tracker instance or fallback to a no-op implementation

    const g: any = globalThis as any
    return (
      g.__LAST_TRACKER__ || {
        identify: () => {},
        track: () => {},
        hasFeatureFlag: () => false,
        clear: () => {},
        getRawTracker: () => null
      }
    )
  }

  function identify(): void {
    const tracker = getTracker()
    // Read IDs from localStorage to avoid circular dependency with locations and auth stores
    const selectedOrganizationId = localStorage.getItem('selectedOrganizationId') || ''
    const selectedLocationId = localStorage.getItem('selectedLocationId') || ''
    const userId = localStorage.getItem('userId') || ''
    const accessToken = localStorage.getItem('accessToken') || ''

    const userData = {
      id: selectedLocationId || selectedOrganizationId || userId,
      userId,
      location_id: selectedLocationId,
      organization_id: selectedOrganizationId,
      accessToken
    } as unknown as TrackingUserData

    // Keep a copy and notify trackers
    currentUserData.value = userData
    tracker.identify(userData)
  }

  return {
    identify
  }
})
